import { Component, Prop, Vue } from 'vue-property-decorator'
import {
    Status
} from '@/cellRenderers/common/has-unauthorized-billable-concepts-icon/has-unauthorized-billable-concepts-icon-model'

@Component
export default class HasUnauthorizedBillableConceptsIcon extends Vue {
    @Prop() readonly status!: Status
}
